import * as React from 'react';
import { Box, Stack, Typography, alpha, useTheme } from '@mui/material';

import { appBarColors } from './appBarTheme';

/**
 * The brand lockup in the app bar.
 *
 * Was a bare <strong>Pratham</strong>, which is why the top of every screen
 * read as unstyled text rather than as a product. It is now a mark plus a
 * wordmark plus what the panel actually is, so the bar carries some identity
 * instead of one word floating in the middle of it.
 *
 * Colours come from the theme rather than being fixed, because the panel ships
 * six swappable themes and a dark mode; a hard-coded logo colour is the first
 * thing to look wrong the moment somebody changes the palette.
 */
const Logo = () => {
    const theme = useTheme();
    const { fg } = appBarColors(theme);

    return (
        <Stack direction="row" spacing={1.25} alignItems="center" sx={{ ml: 0.5 }}>
            <Box
                sx={{
                    width: 34,
                    height: 34,
                    borderRadius: 2,
                    display: 'grid',
                    placeItems: 'center',
                    fontWeight: 800,
                    fontSize: 16,
                    letterSpacing: '.02em',
                    color: fg,
                    bgcolor: alpha(fg, 0.18),
                    border: `1px solid ${alpha(fg, 0.35)}`,
                    backdropFilter: 'blur(4px)',
                }}
            >
                P
            </Box>
            <Box sx={{ lineHeight: 1.1 }}>
                <Typography
                    component="span"
                    sx={{
                        display: 'block',
                        fontWeight: 800,
                        fontSize: 16,
                        letterSpacing: '.04em',
                        color: fg,
                    }}
                >
                    Pratham
                </Typography>
                <Typography
                    component="span"
                    sx={{
                        display: 'block',
                        fontSize: 10.5,
                        fontWeight: 600,
                        letterSpacing: '.14em',
                        textTransform: 'uppercase',
                        color: alpha(fg, 0.72),
                    }}
                >
                    Admin Console
                </Typography>
            </Box>
        </Stack>
    );
};

export default Logo;
